document.addEventListener('DOMContentLoaded', function () {
  const giftSaveButton = document.querySelector('#cart-gift-box-save-btn')

  /* -------------------------------------------------------------
   * Gift-box debugging utilities
   * -------------------------------------------------------------
   *  – Set the flag below to false to silence the verbose console
   *    output in production.
   *  – Use the helper instead of bare console.log so we can quickly
   *    grep for `[GiftBox Debug]` messages and keep a consistent
   *    colour scheme in DevTools.
   * ----------------------------------------------------------- */

  // Toggle this flag at runtime from the console if required
  window.__GIFTPROPS_DEBUG__ = true

  /**
   * Pretty logger for all gift-box related console output.
   * @param {string} message  – short description of what we are logging
   * @param {*}      payload  – any data we want to inspect
   */
  function logGiftboxDebug(message, payload) {
    if (!window.__GIFTPROPS_DEBUG__) return
    // Using violet so it stands out in Chrome/FireFox console
    console.log(`%c[GiftBox Debug] ${message}`, 'color:#8A2BE2;font-weight:bold', payload)
  }

  // Event listener for checkbox change
  document.addEventListener('change', function (event) {
    if (event.target.matches('.gifting-option-checkbox-input')) {
      const el = event.target
      const parents = el.closest('.cart-gift-drawer-items')
      const errorContainer = document.querySelector('#gift-drawer-error-message')

      if (el.checked === true) {
        parents.setAttribute('data-item-cart-action', 'add')
      } else {
        parents.setAttribute('data-item-cart-action', 'remove')
      }

      // Undoes the disabled state that is added when gift box quantity is invalid
      errorContainer.style.display = 'none'
      giftSaveButton.removeAttribute('disabled')
    }
  })

  // Event listener for textarea
  document.addEventListener('change', function (event) {
    if (event.target.matches('.cart-gifting-drawer-textarea')) {
      const el = event.target
      const parents = el.closest('.cart-gift-drawer-items')

      // Only need to update note, not add new lines
      parents.setAttribute('data-item-cart-action', 'update')
    }
  })

  closeDrawer = () => {
    const cartGiftOptionDrawer = document.querySelector(
      'cart-gift-option-drawer'
    )
    cartGiftOptionDrawer.classList.remove('open')
    document.body.classList.remove('overflow-hidden--drawer-open')
    document.documentElement.classList.remove('overflow-hidden--drawer-open')
  }

  // Use event delegation to handle dynamically added buttons
  document.addEventListener('click', function (event) {
    if (event.target.matches('#cart-gift-box-save-btn')) {
      // Also keep the original check for backwards compatibility
      if (giftSaveButton) {
        let dataObject = []
        const clickedElement = event.target

        if (clickedElement.getAttribute('type') == 'submit') {
          // Check that the desired gift box quantity is valid.
          if (!isGiftBoxQuantityValid()) {
            const errorContainer = document.querySelector(
              '#gift-drawer-error-message'
            )

            errorContainer.style.display = 'block'
            errorContainer.innerHTML = window.giftingStrings.outOfStockError
            giftSaveButton.setAttribute('disabled', 'disabled')
            return
          }

          const drawerWrap = clickedElement.closest('.cart-gift-option-drawer')
          const timestampItemKeyMap = {}

          /**
           * Store a count value that gets incremented in each loop.
           * - Helps ensures that the groupId is unique when multiple edits are
           *   triggered at once.
           */
          let count = 0
          const cartGiftDrawerItems = drawerWrap.querySelectorAll('.cart-gift-drawer-items')
          cartGiftDrawerItems.forEach(function (item) {
            const actionType = item.getAttribute('data-item-cart-action')
            const itemKey = item.getAttribute('data-itemkey')
            const parentId = item.getAttribute('data-id')
            const groupId = item.getAttribute('data-group-id')
            const quantity = item.getAttribute('data-line-quantity')
            const isAddon = item.getAttribute('data-is-addon') === 'true'
            const addonType = item.getAttribute('data-addon-type')

            /**
             * Get item properties as an object.
             * - Retrieve properties from data attribute.
             * - Parse string to JSON
             * - Convert JSON array of key pair values into an object using
             *   `Object.fromEntries`
             * - Existing properties object is used to ensure existing non-gift
             *   properties remain on the product after updates.
             */
            const existingPropertiesAttribute = item.getAttribute('data-properties')
            const existingPropertiesJSON = JSON.parse(existingPropertiesAttribute)
            const existingProperties = Object.fromEntries(existingPropertiesJSON)

            if (actionType != 'added') {
              const checkboxInput = item.querySelector('input')
              if (checkboxInput && checkboxInput.checked) {
                // Get the newly selected gift box variant ID from the checked radio button
                const checkedGiftBoxInput = item.querySelector('.gifting-option-checkbox-input:checked')
                const newlySelectedGiftId = checkedGiftBoxInput
                  ? checkedGiftBoxInput.value
                  : item.getAttribute('data-gift-box-id') // fallback to existing gift box

                // Use the newly selected gift box ID
                const giftId = newlySelectedGiftId

                const mainProductTitle = item.getAttribute('data-title')
                const giftBoxExist = item.getAttribute('data-gift-item-exist')

                // Get the newly selected gift box handle from the checked radio button
                const newlySelectedGiftHandle = checkedGiftBoxInput
                  ? checkedGiftBoxInput.getAttribute('data-product-handle')
                  : item.getAttribute('data-product-handle') // fallback to existing handle

                const giftProductHandle = newlySelectedGiftHandle
                const noteDiv = item.querySelector(
                  '.gifting-drawer-textarea-box textarea'
                )
                const noteValue = noteDiv ? noteDiv.value : ''

                const dateNow = Date.now()
                const newGroupId = groupId || dateNow + count * 1000
                count++

                // Validate that we have all required IDs
                if (!parentId) {
                  console.error('parentId is null or undefined:', parentId)
                  return
                }
                if (!giftId) {
                  console.error('giftId is null or undefined:', giftId)
                  return
                }
                if (!itemKey) {
                  console.error('itemKey is null or undefined:', itemKey)
                  return
                }

                /**
                 * Remove old product and add new one approach:
                 * - First remove the existing product by setting quantity to 0
                 * - Then add the new product with updated properties
                 * - If gift box already exists, also remove and re-add it
                 */

                // Remove the existing main product
                const removeMainProductLine = {
                  actionType: 'update',
                  id: itemKey,
                  quantity: 0,
                }

                // Add the new main product with updated properties
                const addMainProductLine = {
                  actionType: 'add',
                  id: parseInt(parentId), // Ensure ID is a number
                  quantity: parseInt(quantity),
                  properties: {
                    ...existingProperties,
                    Note: noteValue,
                    _hasGiftBox: true,
                    _giftboxId: giftId,
                    _groupId: newGroupId,
                    _giftProductHandle: giftProductHandle,
                  },
                }

                if (giftBoxExist == 'true') {
                  const existingGiftBoxId = item.getAttribute('data-gift-box-id')

                  // If data attribute is missing we can't target the old gift box –
                  // treat this case as "no gift yet" to avoid sending an update with
                  // an empty id which breaks the cart API.
                  if (!existingGiftBoxId) {
                    console.warn('[GiftBox Debug] expected data-gift-box-id but none found – skipping removal');
                  }

                  const giftChanged = existingGiftBoxId && giftId != existingGiftBoxId

                  if (giftBoxExist === 'true' && !giftChanged) {
                    // Mark its gift-box row as UPDATE on the current .cart-gift-drawer-items element
                    item.setAttribute('data-item-cart-action', 'update')
                  }

                  if (giftChanged) {
                    // Remove old gift and add the newly selected one
                    // Only push a removal if we have a valid line-item id.
                    const removeGiftProductLine = existingGiftBoxId ? {
                      actionType: 'update',
                      id: existingGiftBoxId,
                      quantity: 0,
                    } : null;

                    const addGiftProductLine = {
                      actionType: 'add',
                      id: parseInt(giftId),
                      quantity: parseInt(quantity),
                      properties: {
                        'Gift Box With': mainProductTitle,
                        _parentPid: parentId,
                        _groupId: newGroupId,
                        _addon: true,
                        _addonType: 'Gift Box',
                        _giftProductHandle: giftProductHandle,
                      },
                    }

                    if (removeGiftProductLine) {
                      dataObject.push(removeMainProductLine, removeGiftProductLine, addMainProductLine, addGiftProductLine)
                    } else {
                      dataObject.push(removeMainProductLine, addMainProductLine, addGiftProductLine)
                    }
                  } else {
                    // Gift box unchanged. Update main product only (note or other properties)
                    const cleanedProps = { ...existingProperties };
                    cleanedProps.Note = noteValue;

                    const updateMainProductLine = {
                      actionType: 'update',
                      id: itemKey,
                      quantity: parseInt(quantity),
                      properties: cleanedProps,
                    }

                    // Replace entire dataObject with just the single update
                    dataObject = [updateMainProductLine];
                    // Exit the .each loop early
                    return false;
                  }
                } else if (actionType !== 'update') {
                  // Only add gift box when user has (re)checked the option
                  const addGiftProductLine = {
                    actionType: 'add',
                    id: parseInt(giftId),
                    quantity: parseInt(quantity),
                    properties: {
                      'Gift Box With': mainProductTitle,
                      _parentPid: parentId,
                      _groupId: newGroupId,
                      _addon: true,
                      _addonType: 'Gift Box',
                      _giftProductHandle: giftProductHandle,
                    },
                  }

                  dataObject.push(removeMainProductLine, addMainProductLine, addGiftProductLine)
                }
              } else if (actionType === 'remove') {
                /**
                 * Remove old product and add new one when removing a gift box
                 * - Remove the existing product completely
                 * - Add it back without gift box properties
                 * - If the product has personalisation, keep the groupId
                 *   so that main product and personalisation remain linked.
                 */

                const hasPersonalisation = Boolean(
                  existingProperties[
                    window.personalisationStrings?.initialsProperty
                  ]
                )

                const newProperties = { ...existingProperties }

                // Validate that we have all required IDs
                if (!parentId) {
                  console.error('parentId is null or undefined:', parentId)
                  return
                }
                if (!itemKey) {
                  console.error('itemKey is null or undefined:', itemKey)
                  return
                }

                /**
                 * Remove old product and add new one approach:
                 * - First remove the existing product by setting quantity to 0
                 * - Then add the new product with updated properties
                 * - If gift box already exists, also remove and re-add it
                 */

                // Remove the existing main product
                const removeMainProductLine = {
                  actionType: 'update',
                  id: itemKey,
                  quantity: 0,
                }

                // Add the main product back without gift box properties
                const addMainProductLine = {
                  actionType: 'add',
                  id: parseInt(parentId), // Ensure ID is a number
                  quantity: parseInt(quantity),
                  properties: newProperties,
                }

                // Always attempt to remove the linked gift box using data attribute fallback
                const fallbackGiftId = item.getAttribute('data-gift-box-id')
                if (fallbackGiftId) {
                  dataObject.push({ actionType: 'update', id: fallbackGiftId, quantity: 0 })
                }

                dataObject.push(removeMainProductLine, addMainProductLine)

                // By now we should already have a gift to remove
                const giftKey = timestampItemKeyMap[groupId]
                if (giftKey) {
                  const payloadForGiftBoxRemove = {
                    actionType: 'update',
                    id: giftKey,
                    quantity: 0,
                  }

                  dataObject.push(payloadForGiftBoxRemove)
                }
              } else if (groupId && isAddon && addonType === 'Gift Box') {
                timestampItemKeyMap[groupId] = itemKey
              }
            }
          })

          // Check dataObj length
          if (dataObject.length > 0) {
            try {
              const selected = drawerWrap.querySelector('.gifting-option-checkbox-input:checked');
              logGiftboxDebug('Selected gift', {
                id: selected?.value,
                handle: selected?.getAttribute('data-product-handle'),
              });
            } catch (e) {}
            // Setting aria label attribute
            clickedElement.setAttribute('aria-disabled', 'true')

            // Log payload for debugging in a structured manner
            logGiftboxDebug('Cart payload (pre-dedupe)', dataObject)

            // Adding loading state
            clickedElement.classList.add('loading')
            const loadingSpinner = clickedElement.querySelector('.loading__spinner')
            if (loadingSpinner) {
              loadingSpinner.classList.remove('hidden')
            }
            const unique = [];
            const seen = new Set();
            dataObject.forEach(op => {
              if (op.actionType === 'add' && seen.has(op.id)) return;
              if (op.actionType === 'add') seen.add(op.id);
              unique.push(op);
            });
            // Extra logging after duplicate-removal so we can follow exactly
            // which lines will be sent to the cart API.
            logGiftboxDebug('Cart payload (deduped)', unique)

            // Highlight just the gift-box lines for quick scanning.
            unique
              .filter(op => op.properties && op.properties._addonType === 'Gift Box')
              .forEach(op => logGiftboxDebug('GiftBox line item', op))

            logGiftboxDebug('Cart payload (final to send)', unique)
            addAllItems(unique, clickedElement)
          } else {
            // Close the drawer
            closeDrawer()
          }
        }
      }
    }
  })

  /**
   * Check if the user's requested gift box stock is valid.
   * - Loops through the gift lines to get the following:
   *   - Whether the product has a linked gift box item
   *   - The current stock of the linked gift box item, added as a data
   *     attribute `data-gift-box-quantity`
   *     - The stock level is set to Infinity if Shopify is not tracking stock,
   *       grabbed from a data attribute `data-gift-box-check-quantity`
   *   - The desired stock, calculated from the main product's quantity and
   *     whether the user is adding or updating a gift box, based on the
   *     `data-item-cart-action` attribute
   * - Then compares the desired stock against the inventory stock to make sure
   *   that for every gift box variant id the desired quantity is less that or\
   *   equal to the available stock
   * @returns {Boolean} whether requested gift box stock amount is valid
   */
  function isGiftBoxQuantityValid() {
    const drawerElement = document.querySelector('.cart-gift-option-drawer')
    const lineItems = drawerElement.querySelectorAll('.cart-gift-drawer-items')

    // Set up objects to store desired and requested quantities.
    const giftBoxInventoryQuantity = {}
    const giftBoxDesiredQuantity = {}

    lineItems.forEach(lineItem => {
      const linkedGiftBoxId = lineItem.dataset.giftBoxId
      const linkedGiftBoxQuantity = lineItem.dataset.giftBoxQuantity
      const linkedGiftBoxCheckQuantity =
        lineItem.dataset.giftBoxCheckQuantity === 'true'

      if (!linkedGiftBoxId) {
        return
      }

      giftBoxInventoryQuantity[linkedGiftBoxId] = linkedGiftBoxCheckQuantity
        ? Number(linkedGiftBoxQuantity)
        : Infinity

      const itemQuantity = Number(lineItem.dataset.lineQuantity)
      const giftAdded = ['add', 'added'].includes(
        lineItem.dataset.itemCartAction
      )
      const desiredQuantity = giftAdded ? itemQuantity : 0

      giftBoxDesiredQuantity[linkedGiftBoxId] = giftBoxDesiredQuantity[
        linkedGiftBoxId
      ]
        ? giftBoxDesiredQuantity[linkedGiftBoxId] + desiredQuantity
        : desiredQuantity
    })

    const isQuantityValid = Object.keys(giftBoxDesiredQuantity).every(key => {
      return giftBoxDesiredQuantity[key] <= giftBoxInventoryQuantity[key]
    })

    return isQuantityValid
  }

  // Add to cart ajax for gift box products
  async function addAllItems(dataItems, $this) {
    /**
     * Sort cart updates to ensure proper order:
     * 1. First process all removals (updates with quantity 0)
     * 2. Then process all additions
     * - This ensures we free up inventory before trying to add new items
     * - Prevents stock conflicts when removing and adding gift boxes
     */
    const sortedCartUpdates = [...dataItems].sort((a, b) => {
      // Removals (updates with quantity 0) come first
      const aIsRemoval = a.actionType === 'update' && a.quantity === 0
      const bIsRemoval = b.actionType === 'update' && b.quantity === 0

      if (aIsRemoval && !bIsRemoval) return -1
      if (!aIsRemoval && bIsRemoval) return 1

      // Then regular updates
      if (a.actionType === 'update' && b.actionType !== 'update') return -1
      if (a.actionType !== 'update' && b.actionType === 'update') return 1

      // Finally additions
      if (a.actionType === 'add' && b.actionType !== 'add') return 1
      if (a.actionType !== 'add' && b.actionType === 'add') return -1

      return 0
    })

    for (let data of sortedCartUpdates) {
      const actionType = data.actionType
      const url =
        actionType === 'add' ? routes.cart_add_url : routes.cart_change_url

      // Log each individual request so we can trace its lifecycle.
      logGiftboxDebug(`Cart ${actionType} request`, data)

      if (!data.id) {
        // Skip invalid operation silently
        continue
      }

      try {
        const response = await fetch(url, {
          ...fetchConfig(),
          body: JSON.stringify(data),
        })

        if (!response.ok) {
          // Shopify returns 422 when trying to update a line that no longer exists.
          // Treat that as success if we were attempting to remove it (quantity 0).
          if (response.status === 422 && data.actionType === 'update' && data.quantity === 0) {
            continue
          }

          const errorText = await response.text()
          console.error('Cart operation failed:', {
            status: response.status,
            statusText: response.statusText,
            error: errorText,
            data: data
          })
        }
      } catch (error) {
        console.error('Cart operation error:', error, 'Data:', data)
      }
    }

    // Reloading cart drawer contents and cart bubble in header.
    updateCart()

    // Setting aria label attribute
    $this.setAttribute('aria-disabled', 'false')

    // Adding loading state
    $this.classList.remove('loading')
    const loadingSpinner = $this.querySelector('.loading__spinner')
    if (loadingSpinner) {
      loadingSpinner.classList.add('hidden')
    }

    closeDrawer()
  }

  /**
   * Fetch the latest cart state and update sections.
   * - Fetches the latest cart state and then updates the cart sections to show
   *   the new data.
   */
  function updateCart() {
    fetch(
      `${routes.cart_url}?sections=${getSectionsToRender().map(
        section => section.section
      )}`
    )
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state)

        getSectionsToRender().forEach(section => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)

          elementToReplace.innerHTML = getSectionInnerHTML(
            parsedState[section.section],
            section.selector
          )
        })
      })
      .catch(e => {
        console.error(e)
      })
  }

  function getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  // Function to check if the gift box or message has been added
  function checkGiftBoxSelection() {
    const giftBoxContent = document
      .querySelector('#selected-gift-box')
      .textContent.trim()
    const giftBox = document.querySelector(".gift-box-checkbox:checked");
    const giftMessage = document.querySelector('#gift-message').value.trim()
    const giftBoxVariantInput = document.querySelector('#gift-box-variant-id')
    const isGiftBoxAdded = document.querySelector('#gift-box-for-product')
    const selectedGiftMessage = document.querySelector('#selected-gift-message')
    const mainVariantId = document.querySelector('#main__variantId')
    const giftVariantId = document.querySelector('#gift__variantId')
    const hasGiftBoxId = document.querySelector('#hasgiftboxId')
    const mainProductGroupId = document.querySelector('#main-product-groupId')
    const giftProductGroupId = document.querySelector('#gift-box-groupId')
    const giftProductAddon = document.querySelector('#gift-box-addon')
    const giftProductAddonType = document.querySelector('#gift-box-addon-type')

    updateGiftGroupIdInputs()

    if (giftBoxContent && giftBox) {
      giftBoxVariantInput.disabled = false
      isGiftBoxAdded.disabled = false
      selectedGiftMessage.disabled = false
      mainVariantId.disabled = false
      giftVariantId.disabled = false
      hasGiftBoxId.disabled = false
      mainProductGroupId.disabled = false
      giftProductGroupId.disabled = false
      giftProductAddon.disabled = false
      giftProductAddonType.disabled = false
    } else {
      giftBoxVariantInput.disabled = true
      isGiftBoxAdded.disabled = true
      selectedGiftMessage.disabled = true
      mainVariantId.disabled = true
      giftVariantId.disabled = true
      hasGiftBoxId.disabled = true
      mainProductGroupId.disabled = true
      giftProductGroupId.disabled = true
      giftProductAddon.disabled = true
      giftProductAddonType.disabled = true
    }

    if (giftBox) {
      selectedGiftMessage.disabled = false;
    } else {
      selectedGiftMessage.disabled = true;
    }
  }

  /**
   * Update the Group ID hidden inputs with a new timestamp to ensure the group
   * id is always unique.
   */
  function updateGiftGroupIdInputs() {
    const timestamp = Date.now().toString()
    const mainProductGroupId = document.querySelector('#main-product-groupId')
    const giftProductGroupId = document.querySelector('#gift-box-groupId')

    if (mainProductGroupId) {
      mainProductGroupId.value = timestamp
    }

    if (giftProductGroupId) {
      giftProductGroupId.value = timestamp
    }
  }

  // Update the hidden input field when the user confirms their gift box selection
  const confirmGifting = document.querySelector('#confirm-gifting')

  if (confirmGifting) {
    confirmGifting.addEventListener('click', function () {
      checkGiftBoxSelection()
    })

    /**
     * Update Group ID inputs on variant change.
     */
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      updateGiftGroupIdInputs()
    })
  }

  // Initial check on page load
  const giftBoxInput = document.querySelector('#selected-gift-box')

  if (giftBoxInput) {
    checkGiftBoxSelection()
  }
})
